export default "__VITE_ASSET__BDKTs_h6__"